import type { IconSvgObject } from './types';

const ArrowDownRight01Icon: IconSvgObject = [
  ["path", { d: "M17.5 9V17.5H9.00003M17.0714 17.0714L6.50003 6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ArrowDownRight01Icon;
